import { ParsedUrlQuery } from "querystring";

import { GetServerSideProps } from "next";
import { FC } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Category } from "@prisma/client";

import prisma, { getStaticData } from "@lib/prisma";
import { StaticProps } from "@interfaces/page";
import Layout from "@components/common/layout";
import InquiryComponent from "@components/inquiry/inquiry-form";

interface Props extends StaticProps {
  category: Category;
  url?: string;
}

interface PathProps extends ParsedUrlQuery {
  category: string;
}

const Inquiry: FC<Props> = ({ category, url }) => {
  const { t } = useTranslation("forms");

  return (
    <Layout
      {...{ title: t("inquiry.title"), description: t("inquiry.description") }}
    >
      <div className="space-y-10 my-10 w-full max-w-5xl mx-auto px-4">
        <h1 className="font-bold text-4xl text-center">{t("inquiry.send")}</h1>
        <InquiryComponent {...{ category, url }} />
      </div>
    </Layout>
  );
};

export default Inquiry;

export const getServerSideProps: GetServerSideProps<Props, PathProps> = async ({
  params,
  query,
  locale,
}) => {
  if (!params || !params.category) {
    return { notFound: true };
  }

  const [category, staticData] = await getStaticData([
    prisma.category.findUnique({ where: { slug: params.category } }),
  ]);

  if (!category) {
    return { notFound: true };
  }

  const translations = await serverSideTranslations(locale as string, [
    "common",
    "forms",
  ]);

  return {
    props: {
      ...query,
      category,
      staticData,
      ...translations,
    },
  };
};
